export const APP_NAME = "DSS Products";

/** Every API route is mounted under this prefix, on the same origin as the SPA. */
export const API_PREFIX = "/api";

/** Stamped into exported scenario documents so an import can recognise its own format. */
export const EXPORT_SCHEMA = "roi-explorer-scenario";
export const EXPORT_VERSION = 1;

/** The format the current ZNMS page emits; accepted by the importer via legacy.ts. */
export const LEGACY_EXPORT_SCHEMA = "znms-roi-scenario";

export const MIN_HORIZON_YEARS = 2;
export const MAX_HORIZON_YEARS = 10;
export const DEFAULT_HORIZON_YEARS = 5;
export const MIN_COMMITMENT_YEARS = 0;
export const MAX_COMMITMENT_YEARS = 5;
/** Two years is the shortest commitment the current contracts use. */
export const DEFAULT_COMMITMENT_YEARS = 2;
export const MIN_PACKAGES = 1;
export const MAX_PACKAGES = 12;

/** Package series slots in the palette — see docs/09-theme.md. */
export const PACKAGE_COLOR_SLOTS = 6;

/** A comparison reads as a matrix, and more than four columns stops reading — docs/08. */
export const MIN_COMPARE_SCENARIOS = 2;
export const MAX_COMPARE_SCENARIOS = 4;
